import React from "react";
import NamedResourceList from "../curriculum/components/named-resource-list";
import {cvBenefitService} from "../../services/curriculum-resource-service";

const CvBenefit = () => (
    <NamedResourceList title="Benefícios" newLabel="Novo benefício" basePath="/cv/benefit"
                       queryKey="cv-benefits" service={cvBenefitService}/>
);

export default CvBenefit;
